import { endPoints, requestType } from "../constants/variables";
import Api from "./index";

const createSession = (payload) => {
  return Api(endPoints.createFaceLivenessSession, payload, requestType.POST);
};

// const createSession = (payload, token) => {
//   return Api(
//     endPoints.createFaceLivenessSession,
//     payload,
//     requestType.POST,
//     token
//   );
// };

const startVerification = (sessionId) => {
  return Api(
    `${endPoints.startVerificationSession}/${sessionId}/start`,
    null,
    requestType.POST
  );
};

const verifyProcess = (sessionId, payload) => {
  return Api(
    `${endPoints.verifyFace}/${sessionId}`,
    payload,
    requestType.POST
  );
};

const trackPageVisiting = (sessionId) => {
  return Api(
    `${endPoints.trackPageVisiting}/${sessionId}/track`,
    null,
    requestType.POST
  );
};

const getConfig = (sessionId) => {
  return Api(
    `${endPoints.startVerificationSession}/${sessionId}/config`,
    null,
    requestType.GET
  );
};

const getSessionStatus = (sessionId) => {
  return Api(
    `${endPoints.startVerificationSession}/${sessionId}/status`,
    null,
    requestType.GET
  );
};

const cancelVerification = (sessionId) => {
  return Api(
    `${endPoints.startVerificationSession}/${sessionId}/cancel`,
    null,
    requestType.POST
  );
};

const reportFailure = (sessionId, payload) => {
  return Api(
    `${endPoints.startVerificationSession}/${sessionId}/report-failure`,
    payload,
    requestType.POST
  );
};

export { createSession, startVerification, verifyProcess, trackPageVisiting, getConfig, getSessionStatus, cancelVerification, reportFailure };
